module.exports = __webpack_public_path__ + "static/img/advantage4.21c361ad.png";